


















































import Vue from 'vue';
import {Prop, Watch} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {COLOR_SERVICE_INSTANCE, ColorService} from '@/services/style/color.service';
import {ICONS_SERVICE_INSTANCE, IconsService} from '@/utils/icons.service';

@Component({
  name: 'Alert',
})
export default class AmetrasAlertTemplate extends Vue {

  @Prop() typeSpecificSettings!: DisguiseDto.AlertSpecificSettings;
  colorService: ColorService = COLOR_SERVICE_INSTANCE;
  iconService: IconsService = ICONS_SERVICE_INSTANCE;
  border: 'top' | 'bottom' | 'right' | 'left' | null = null;
  type: 'success' | 'info' | 'warning' | 'error' | null = null;
  percentageAutoClose: number = 0;
  value: boolean = true;
  private runningInterval: number | undefined;
  private runningTimeout: number | undefined;

  @Watch('typeSpecificSettings') typeSpecificSettingsChanged(newValue: DisguiseDto.AlertSpecificSettings) {
    if (this.runningInterval !== undefined) {
      clearInterval(this.runningInterval);
      this.runningInterval = undefined;
    }
    if (this.runningTimeout !== undefined) {
      clearTimeout(this.runningTimeout);
      this.runningTimeout = undefined;
    }
    this.typeSpecificSettings = newValue;
    this.value = true;
    this.refreshProps();
  }

  created() {
    this.refreshProps();
  }

  close() {
    this.value = false;
    if (this.runningInterval !== undefined) {
      clearInterval(this.runningInterval);
      this.runningInterval = undefined;
    }
    if (this.runningTimeout !== undefined) {
      clearTimeout(this.runningTimeout);
      this.runningTimeout = undefined;
    }
    this.$emit('close');
  }

  private refreshProps() {
    switch ((this.typeSpecificSettings || {}).border || '') {
      case 'BOTTOM':
        this.border = 'bottom';
        break;
      case 'TOP':
        this.border = 'top';
        break;
      case 'LEFT':
        this.border = 'left';
        break;
      case 'RIGHT':
        this.border = 'right';
        break;
      default:
        this.border = null;
        break;
    }
    switch ((this.typeSpecificSettings || {}).alertType || '') {
      case 'SUCCESS':
        this.type = 'success';
        break;
      case 'INFO':
        this.type = 'info';
        break;
      case 'WARNING':
        this.type = 'warning';
        break;
      case 'ERROR':
        this.type = 'error';
        break;
      default:
        this.type = null;
        break;
    }

    const autoCloseIntervalSeconds = this.typeSpecificSettings.autoCloseIntervalSeconds;
    if (autoCloseIntervalSeconds !== undefined) {
      let intervallCount = 1;
      this.runningInterval = setInterval(() => {
        intervallCount = intervallCount + 1;
        this.percentageAutoClose = 50 * intervallCount / autoCloseIntervalSeconds;
      }, 500); // every 100 ms

      this.runningTimeout = setTimeout(
          this.close,
          autoCloseIntervalSeconds * 1000
      );
    }
  }
}

